import { memo } from 'react'
import { Box } from '@mui/material'

import balanceIcon from '../../assets/images/balance-icon.png'

const StakingIcon = () => {
  return (
    <Box
      component='img'
      src={balanceIcon}
      sx={{ aspectRatio: '1/1', minWidth: 120, maxWidth: 280 }}
    />
  )
}

export default memo(StakingIcon)
